import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { removeClientData } from "../../../../data/redux/slice/clientOnboardDataSlice";
import {
  clearGlobalFilterReducer,
  showHideFilterModalReducer,
} from "../../../../data/redux/slice/globalFiltersSlice";
import { modalNavigation } from "../../../../data/redux/slice/modalNavigationSlice";
import { setHeaders } from "../../../../services/aclValidateServiceTable";
import { fecthClientList } from "../../../../services/fetchListingData";
import {
  colorDarkBlue,
  colorWhite,
  primaryColor,
} from "../../../../utility/constants/colorManager";
import CheckBoxInput from "../../../components/ui_comps/CheckBoxInput";
import {
  ACTIVATE,
  ACTIVE,
  APPROVED,
  CHARGE_BACK_ACL,
  CLIENTS_ADD_ACL,
  CLIENTS_ALL_ACL,
  CLIENTS_PAYIN_ACL,
  CLIENTS_PAYOUT_ACL,
  CLIENTS_VAN_ACL,
  CLIENTS_VAN_UPI_ACL,
  CLIENTS_VIEWMORE_ACL,
  CLIENT_DOWNLOAD_ACL,
  DEACTIVATE,
  STATUS_CODE_200,
} from "../../../../utility/constants/valueConstants";
import { setTabsAccToAcl } from "../../../../utility/convertors";
import ResizeListner from "../../../../utility/ResizeListner";
import { MainClientHeaders } from "../../../../utility/TableHeaders";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomTable from "../../../components/main_comps/custom_table";
import CustomTabs from "../../../components/main_comps/custom_tabs";
import AlertModals from "../../../components/ui_comps/AlertModals";
import CommissionModal from "../../../components/ui_comps/CommissionModal";
import MainComponent from "../../../components/ui_comps/MainComponent";
import ClientOnboardIndex from "./client_onboard";
import DownloadReportClient from "./DowloadReportClient";
import { removeServiceData } from "../../../../data/redux/slice/addService";
import secureStorage from "../../../../services/secureStorage";
import { SS_INTERNAL } from "../../../../utility/constants/secureStorageManager";
import ChargeBackClient from "./ChargeBackReport";
import ChargeBackTableClient from "./ChargeBackTable";


export const ChargeBackComponent = ({ onClick }) => {
  const aclData = useSelector((state) => state.aclSlice.aclList);
  return (
    <div style={{ display: "flex" }}>
      {
        aclData.includes(CHARGE_BACK_ACL) && (
          <CustomButton
            styles={{
              backgroundColor: "#38369C",
              border: "1px solid #38369C",
              marginLeft: "10px",
            }}
            title="Chargeback"
            textStyles={{ color: "white" }}
            onClick={onClick}
          />
        )
      }

    </div>
  );
};

export const ActionComponent = ({ onClick }) => {
  return (
    <div style={{ display: "flex" }}>
      <CustomButton
        styles={{
          backgroundColor: "#38369C",
          border: "1px solid #38369C",
          marginLeft: "10px",
        }}
        title="Download Report"
        textStyles={{ color: "white" }}
        onClick={onClick}
      />
    </div>
  );
};

export const tabs = [
  { name: "All", key: 0, aclValue: CLIENTS_ALL_ACL },
  { name: "Payin", key: 1, aclValue: CLIENTS_PAYIN_ACL },
  { name: "Payout", key: 2, aclValue: CLIENTS_PAYOUT_ACL },
  { name: "Van", key: 3, aclValue: CLIENTS_VAN_ACL },
  { name: "Upi-Van", key: 4, aclValue: CLIENTS_VAN_UPI_ACL },
];

const ClientIndex = () => {
  const { width, height } = ResizeListner();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(0);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [showChargeBackModal, setShowChargeBackModal] = useState(false);
  const [openToggleModal, setOpenToggleModal] = useState(false);
  const [clientData, setClientData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [onclickAddClient, setOnClickAddClient] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [clientDataRow, setClientDataRow] = useState(false);
  const [openCommissionModal, setOpenCommissionModal] = useState(false);
  const [tabsData, setTabsData] = useState([]);
  const filters = useSelector((state) => state.globalFiltersSlice);
  const currentModalStep = useSelector((state) => state.modalNavSlice);
  const clientListData = useSelector((state) => state.listingSlice.clientList);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const [checked, setChecked] = useState(false);
  const [payin, setPayin] = useState("");
  const [payout, setPayout] = useState("");
  const [van, setVan] = useState("");
  const [vanUpi, setVanUpi] = useState("");
  const [voucher, setVoucher] = useState("");
  const [services, setServices] = useState("all");

  const [servicetype, setServiceType] = useState("");
  const internal = secureStorage.getItem(SS_INTERNAL);

  const [payinsubcoreStatus, setPayinCoreStatus] = useState("");
  const [payoutSubcoreStatus, setPayoutSubcoreStatus] = useState("");
  const [vanSubcoreStatus, setVanSubcoreStatus] = useState("");
  const [voucherSubcoreStatus, setVoucherSubcoreStatus] = useState("");
  const [vanUpiSubcoreStatus, setVanUpiSubcorestatus] = useState("");
  const [openNpstModal, setOpenNpstModal] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const handleChange = (event) => {
    if (event.target.value === "payin") {
      setPayinCoreStatus(!payin?.status);
    }
    if (event.target.value === "payout") {
      setPayoutSubcoreStatus(!payout?.status);
    }
    if (event.target.value === "van") {
      setVanSubcoreStatus(!van?.status);
    }
    if (event.target.value === "voucher") {
      setVoucherSubcoreStatus(!voucher?.status);
    }
    if (event.target.value === "van-upi") {
      setVanUpiSubcorestatus(!vanUpi?.status);
    }

    if (event.target.checked) {
      setChecked(true);
      setServiceType(event.target.value);
    } else {
      setChecked(false);
    }
  };

  const onClickChangeStatusOfClient = (
    status,
    clientId,
    reason = "",
    services,
  ) => {
    setLoading(true);

    ApiRequestPost.approveRejectActionStatus({
      status,
      clientId,
      reason,
      service:
        services === "all"
          ? ""
          : [
            {
              serviceProviderName:
                servicetype === "payout"
                  ? payout?.serviceProviderName
                  : servicetype === "van"
                    ? van?.serviceProviderName
                    : servicetype === "van-upi"
                      ? vanUpi?.serviceProviderName
                      : servicetype === "voucher"
                        ? voucher.serviceProviderName
                        : payin?.serviceProviderName,

              status:
                servicetype === "payout"
                  ? payoutSubcoreStatus
                  : servicetype === "van"
                    ? vanSubcoreStatus
                    : servicetype === "van-upi"
                      ? vanUpiSubcoreStatus
                      : servicetype === "voucher"
                        ? voucherSubcoreStatus
                        : payinsubcoreStatus,
              serviceType: servicetype,
            },
          ],
      deactivateSubCore: services === "all" ? "" : true,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          dispatch(
            fecthClientList({
              dateRange:
                filters?.fromDate && filters?.toDate
                  ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                  "-" +
                  moment(filters?.toDate).format("DD/MM/YYYY")
                  : "",
              page: 0,
              size: 10,
              userId: filters?.clientId?.value ?? "",
              serviceType:
                currentTab === 0
                  ? ""
                  : currentTab === 1
                    ? "payin"
                    : currentTab === 2
                      ? "payout"
                      : currentTab === 3
                        ? "van"
                        : currentTab === 4
                          ? "van-upi"
                          : "",
              userRefId: "",
              serviceProviderName: filters?.serviceProvider?.value ?? "",
              onBoardedStatus: APPROVED,
              activeStatus: filters?.status?.value ?? "",
            })
          );
          setConfirm(false);
          setOpenToggleModal(false);
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    dispatch(removeServiceData());
  }, []);

  useEffect(() => {
    let tabData = setTabsAccToAcl(tabs, aclData);
    setTabsData([...tabData]);
    setCurrentTab(tabData[0] ? tabData[0]?.key : 0);

    dispatch(
      fecthClientList({
        dateRange: "",
        page: 0,
        size: 10,
        userId: "",
        activeStatus: "",
        serviceType:
          tabData[0]?.key === 0
            ? ""
            : tabData[0]?.key === 1
              ? "payin"
              : tabData[0]?.key === 2
                ? "payout"
                : tabData[0]?.key === 3
                  ? "van"
                  : tabData[0]?.key === 4
                    ? "van-upi"
                    : "",
        userRefId: "",
        serviceProviderName:
          tabData[0]?.key === 1
            ? "Kopay"
            : tabData[0]?.key === 2
              ? "Cashfree"
              : tabData[0]?.key === 3
                ? "Equitas"
                : "",
        onBoardedStatus: APPROVED,
        deactivatedList: false,
      })
    );
  }, []);

  const [spName, setSpName] = useState("")

  // console.log(spName, "__________spName");

  useEffect(() => {
    dispatch(clearGlobalFilterReducer());
  }, []);
  useEffect(() => {
    if (clientData) {
      const payoutService = clientData?.service.find(
        (e) => e.serviceType === "payout"
      );
      const payinService = clientData?.service.find(
        (e) => e.serviceType === "payin"
      );
      const vanService = clientData?.service.find(
        (e) => e.serviceType === "van"
      );
      const voucherService = clientData?.service.find(
        (e) => e.serviceType === "voucher"
      );
      const vanUpiService = clientData?.service.find(
        (e) => e.serviceType === "van-upi"
      );
      setPayout(payoutService);
      setPayin(payinService);
      setVan(vanService);
      setVoucher(voucherService);
      setVanUpi(vanUpiService);
    }
  }, [clientData]);

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        currentServiceType={
          currentTab === 0
            ? ""
            : currentTab === 1
              ? "payin"
              : currentTab === 2
                ? "payout"
                : currentTab === 3
                  ? "van"
                  : currentTab === 4
                    ? "van-upi"
                    : ""
        }
        notificationRequired={false}
        onClickFilter={() => {
          dispatch(
            showHideFilterModalReducer({
              showFilterModal: true,
              filters: [
                "dateRange",
                "clientName",
                "serviceType",
                "serviceProvider",
                "status",
              ],
            })
          );
        }}
        onClickFilterCall={(data) => {
          dispatch(
            fecthClientList({
              dateRange:
                data?.fromDate && data?.toDate
                  ? moment(data?.fromDate).format("DD/MM/YYYY") +
                  "-" +
                  moment(data?.toDate).format("DD/MM/YYYY")
                  : "",
              page: 0,
              size: 10,
              userId: data?.clientId?.value ?? "",
              activeStatus: data?.status?.value ?? "",
              serviceType:
                currentTab === 0
                  ? data?.serviceType?.value
                    ? data?.serviceType?.value
                    : ""
                  : currentTab === 1
                    ? "payin"
                    : currentTab === 2
                      ? "payout"
                      : currentTab === 3
                        ? "van"
                        : currentTab === 4
                          ? "van-upi"
                          : "",
              serviceProviderName: !internal
                ? "Equitas"
                : data?.serviceProvider?.value ?? "",
              onBoardedStatus: APPROVED,
              resellerName: data?.resellerName,
            })
          );
        }}
        customButtonRequired={
          aclData.includes(CLIENTS_ADD_ACL) ? (
            <CustomButton
              title={"Add Client"}
              styles={{
                backgroundColor: colorDarkBlue,
                border: "none",
                marginLeft: 10,
              }}
              onClick={() => {
                // setOnClickAddClient(true);
                navigate("/clients/onboard");
              }}
              icon={<AiOutlinePlus color="white" />}
            ></CustomButton>
          ) : null
        }
        headerTitle="Clients"
      />
      <CustomTabs
        tabs={tabsData}
        activeIndex={currentTab}
        passCurrentTab={(tab) => {
          setCurrentTab(tab);
          dispatch(
            fecthClientList({
              dateRange:
                filters?.fromDate && filters?.toDate
                  ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                  "-" +
                  moment(filters?.toDate).format("DD/MM/YYYY")
                  : "",
              page: 0,
              size: 10,
              userId: filters?.clientId?.value ?? "",
              activeStatus: filters?.status?.value ?? "",
              serviceType:
                tab === 0
                  ? ""
                  : tab === 1
                    ? "payin"
                    : tab === 2
                      ? "payout"
                      : tab === 3
                        ? "van"
                        : tab === 4
                          ? "van-upi"
                          : "",
              userRefId: "",
              serviceProviderName: !internal
                ? "Equitas"
                : filters?.serviceProvider?.value ?? "",
              onBoardedStatus: APPROVED,
              deactivatedList: false,
            })
          );
        }}
        actionComponent={
          <>
            <div style={{ display: "flex" }}>

              <ChargeBackComponent onClick={() => setShowChargeBackModal(true)} />
              <ActionComponent onClick={() => setShowDownloadModal(true)} />
            </div>
          </>
        }
        isActionComponentRequired={aclData.includes(CLIENT_DOWNLOAD_ACL)}
      />


      <div style={{ padding: "0px 20px", overflow: "hidden" }}>
        <CustomTable
          styles={{
            maxHeight: height * 0.7,
            minHeight: height * 0.7,
          }}
          data={clientListData?.clients}
          headers={setHeaders(MainClientHeaders, aclData, internal)}
          //clientListData?.totolRecords
          totalElements={clientListData?.totalRecords}
          currentPage={clientListData?.currentPageNo - 1}
          //clientListData?.totalPages
          totalPages={clientListData?.totalPages}
          handlePaginate={(page) => {
            dispatch(
              fecthClientList({
                dateRange:
                  filters?.fromDate && filters?.toDate
                    ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                    "-" +
                    moment(filters?.toDate).format("DD/MM/YYYY")
                    : "",
                page: page + 1,
                size: 10,
                userId: filters?.clientId?.value ?? "",
                activeStatus: filters?.status?.value ?? "",
                serviceType:
                  currentTab === 0
                    ? ""
                    : currentTab === 1
                      ? "payin"
                      : currentTab === 2
                        ? "payout"
                        : currentTab === 3
                          ? "van"
                          : currentTab === 4
                            ? "van-upi"
                            : "",
                userRefId: "",
                serviceProviderName: filters?.serviceProvider?.value ?? "",
                onBoardedStatus: APPROVED,
              })
            );
          }}
          onViewMore={(row) => {
            if (aclData.includes(CLIENTS_VIEWMORE_ACL)) {
              navigate("/clients/details", {
                state: {
                  data: row,
                },
              });
            }
          }}
          onStatusChange={(row) => {
            setServices("all");
            setConfirm(true);
            setClientData(row);
          }}
          onViewMoreCommission={(val) => {
            setOpenCommissionModal(true);
            setClientDataRow(val);
          }}
        />
      </div>

      {showDownloadModal && (
        <CustomModal
          headerTitle="Download Report"
          open={showDownloadModal}
          onClose={() => {
            setShowDownloadModal(false);
          }}
          containerStyle={styles.modalContainerStyle}
        >
          <DownloadReportClient />
        </CustomModal>
      )}

      {showChargeBackModal && (
        <CustomModal
          headerTitle="Charge back"
          open={showChargeBackModal}
          onClose={() => {
            setShowChargeBackModal(false);
          }}
          containerStyle={styles.modalContainerStyle}
        >
          <ChargeBackClient
            onNextClick={(tabOpen, selectedSpName) => {
              // console.log(tabOpen, selectedSpName, "______tabOpen");
              if (tabOpen) {
                setSpName(selectedSpName?.value); // Set the selected service provider name
                setOpenNpstModal(true);
              }
              if (!tabOpen) {
                setShowChargeBackModal(false);
              }
            }}
          />
        </CustomModal>
      )}

      {openNpstModal && (
        <CustomModal
          // headerTitle="Custom table"
          open={showChargeBackModal}
          onClose={() => {
            setOpenNpstModal(false);
          }}
          containerStyle={styles.modalChargeBackStyle}
        >

          <ChargeBackTableClient spName={spName} onCloseModal={(modal) => {
            console.log(modal, "Modal")
            if (modal) {
              setOpenNpstModal(false)
              setShowChargeBackModal(false);
            }
          }}
          />

        </CustomModal>
      )}

      {openCommissionModal && (
        <CustomModal
          headerTitle="Slab Commission"
          open={openCommissionModal}
          onClose={() => {
            setOpenCommissionModal(false);
          }}
          containerStyle={{
            minWidth: 300,
            maxWidth: 400,
            height: "auto",
            maxHeight: 800,
          }}
        >
          <CommissionModal data={clientDataRow} />
        </CustomModal>
      )}
      {onclickAddClient && (
        <CustomModal
          headerTitle="Onboard Client"
          open={onclickAddClient}
          onClose={() => {
            setOnClickAddClient(false);
            dispatch(modalNavigation(1));
            dispatch(removeClientData({}));
          }}
          containerStyle={styles.modalContainerStyle}
          isBackRequired={true}
          onClickBack={() => {
            if (currentModalStep > 1) {
              dispatch(modalNavigation(currentModalStep - 1));
            }
          }}
          isConfirmationModalRequired={true}
        >
          <ClientOnboardIndex
            onSuccess={() => {
              setOnClickAddClient(false);
              dispatch(modalNavigation(1));
              dispatch(removeClientData({}));
              dispatch(
                fecthClientList({
                  dateRange: "",
                  page: 0,
                  size: 10,
                  userId: "",
                  activeStatus: "",
                  serviceType: "",
                  userRefId: "",
                  serviceProviderName: "",
                  onBoardedStatus: APPROVED,
                })
              );
            }}
            onClose={() => {
              setOnClickAddClient(false);
            }}
          />
        </CustomModal>
      )}
      {confirm && (
        <CustomModal
          headerTitle=""
          open={confirm}
          onClose={() => {
            setChecked(false);
            setConfirm(false);
          }}
          containerStyle={styles.modalContainerStyle}
        >
          <p
            style={{
              color: primaryColor,
              fontWeight: "500",
              marginBottom: 30,
            }}
          >
            {`Select the Services to be ${clientData?.activeStatus === ACTIVE
              ? "deactivate/activate"
              : "activate/deactivate"
              }`}
          </p>
          <div
            style={{
              display: "flex",
              width: "50%",
              border: "1px solid #ECECEC",
            }}
          >
            <div
              style={{
                flex: 1,
                padding: "10px 0px",
                textAlign: "center",
                fontSize: 14,
                borderRight: "1px solid #ECECEC",
                backgroundColor: services === "all" ? "#ECECEC" : "",
              }}
              onClick={() => {
                setServices("all");
                setChecked(false);
              }}
            >
              All
            </div>
            {payin && (
              <div
                style={{
                  flex: 1,
                  padding: "10px 0px",
                  textAlign: "center",
                  fontSize: 14,
                  backgroundColor: services === "payin" ? "#ECECEC" : "",
                  borderRight: "1px solid #ECECEC",
                }}
                onClick={() => {
                  setServices("payin");
                  setChecked(false);
                }}
              >
                Pay in
              </div>
            )}
            {payout && (
              <div
                style={{
                  flex: 1,
                  padding: "10px 0px",
                  textAlign: "center",
                  fontSize: 14,
                  backgroundColor: services === "payout" ? "#ECECEC" : "",
                }}
                onClick={() => {
                  setServices("payout");
                  setChecked(false);
                }}
              >
                Pay out
              </div>
            )}
            {van && (
              <div
                style={{
                  flex: 1,
                  padding: "10px 0px",
                  textAlign: "center",
                  fontSize: 14,
                  backgroundColor: services === "van" ? "#ECECEC" : "",
                  borderRight: "1px solid #ECECEC",
                }}
                onClick={() => setServices("van")}
              >
                VAN
              </div>
            )}
            {voucher && (
              <div
                style={{
                  flex: 1,
                  padding: "10px 0px",
                  textAlign: "center",
                  fontSize: 14,
                  backgroundColor: services === "voucher" ? "#ECECEC" : "",
                  borderRight: "1px solid #ECECEC",
                }}
                onClick={() => setServices("voucher")}
              >
                Voucher
              </div>
            )}
            {vanUpi && (
              <div
                style={{
                  flex: 1,
                  padding: "10px 0px",
                  textAlign: "center",
                  fontSize: 14,
                  backgroundColor: services === "van-upi" ? "#ECECEC" : "",
                  borderRight: "1px solid #ECECEC",
                }}
                onClick={() => setServices("van-upi")}
              >
                Upi Van
              </div>
            )}
          </div>

          {services === "all" && (
            <CheckBoxInput
              title={"All"}
              value={services}
              onChange={handleChange}
            />
          )}
          {services === "payout" && (
            <CheckBoxInput
              title={payout?.serviceProviderName}
              value={services}
              onChange={handleChange}
            />
          )}
          {services === "payin" && (
            <CheckBoxInput
              title={payin?.serviceProviderName}
              value={services}
              onChange={handleChange}
            />
          )}
          {services === "van" && (
            <CheckBoxInput
              title={van?.serviceProviderName}
              value={services}
              onChange={handleChange}
            />
          )}
          {services === "voucher" && (
            <CheckBoxInput
              title={voucher?.serviceProviderName}
              value={services}
              onChange={handleChange}
            />
          )}
          {services === "van-upi" && (
            <CheckBoxInput
              title={vanUpi?.serviceProviderName}
              value={services}
              onChange={handleChange}
            />
          )}

          <div
            style={{
              display: "flex",
              gap: 20,
              justifyContent: "center",
              marginTop: 30,
            }}
          >
            <CustomButton
              title={"continue"}
              styles={{
                backgroundColor: primaryColor,
                border: "none",
                padding: 0,
                height: "auto",
                padding: "15px 40px",
              }}
              textStyles={{
                color: colorWhite,
              }}
              onClick={() => {
                if (
                  services === "all" ||
                  services === "payin" ||
                  services === "payout" ||
                  services === "van" ||
                  services === "voucher" ||
                  services === "van-upi"
                ) {
                  if (checked) {
                    setOpenToggleModal(true);
                  } else {
                    enqueueSnackbar("Please select any field", {
                      variant: "error",
                    });
                  }
                }
              }}
              disabled={false}
              loading={loading}
            />
          </div>
        </CustomModal>
      )}
      {openToggleModal && (
        <CustomModal
          headerTitle=""
          open={openToggleModal}
          onClose={() => {
            setOpenToggleModal(false);
          }}
          containerStyle={styles.modalContainerStyle}
        >
          <AlertModals
            onClickCancel={() => setOpenToggleModal(false)}
            confirmButtonTitle={"Yes"}
            onClickOk={(reason) => {
              if (reason) {
                if (services === "all") {
                  onClickChangeStatusOfClient(
                    clientData.activeStatus === ACTIVE ? DEACTIVATE : ACTIVATE,
                    clientData?.userId,
                    reason,
                    services
                  );
                  setConfirm(true);
                } else {
                  onClickChangeStatusOfClient("", clientData?.userId, reason);
                }
              } else {
                enqueueSnackbar(
                  `Please enter reason for ${clientData?.activeStatus === ACTIVE
                    ? "Deactivate/Activate"
                    : "Activate/Deactivate"
                  }`,
                  {
                    variant: "error",
                  }
                );
              }
            }}
            loading={loading}
            action={
              clientData?.activeStatus === ACTIVE
                ? "Deactivate/Activate"
                : "Activate/Deactivate"
            }
            reason={
              clientData?.activeStatus === ACTIVE
                ? "Deactivating/Activating"
                : "Activating/Deactivating"
            }
            data={clientData}
          />
        </CustomModal>
      )}
    </div>
  );
};

const styles = {
  modalContainerStyle: {
    minWidth: 350,
    maxWidth: 450,
    height: "auto",
    maxHeight: 800,
  },
  modalChargeBackStyle: {
    minWidth: 350,
    maxWidth: 800,
    height: "auto",
    maxHeight: 800,
  },
};
export default ClientIndex;
